import { SidebarItem } from '@backstage/core-components';
import { useSearchModal } from '@backstage/plugin-search';
import { SearchIcon } from '../../components/icons';
import { isMacPlatform } from './isMacPlatform';

/*
 * The command-palette row at the top of the sidebar.
 *
 * Replaces `SidebarSearchModal`, which renders its own dialog and so kept the
 * open state inside the sidebar. This is the trigger only — the dialog lives in
 * `modules/layout/PortalSearchModal`, and `useSearchModal` reaches its state
 * through the provider in `layoutModule`.
 *
 * The `search-icon` class is load-bearing: `hone-portal.css` styles the raised
 * pill off it, matching what `SidebarSearchModal` used to emit. The extra
 * `search-icon--mac` / `search-icon--other` class picks the ⌘K or Ctrl+K hint
 * off the same `isMacPlatform` check `PortalSearchModal`'s keybind reads, so
 * the badge always matches the shortcut that actually opens the dialog.
 */
export function SidebarSearchTrigger() {
  const { toggleModal } = useSearchModal();
  const platformClass = isMacPlatform() ? 'search-icon--mac' : 'search-icon--other';

  return (
    <SidebarItem
      className={`search-icon ${platformClass}`}
      icon={() => <SearchIcon className="hone-nav-icon" />}
      text="Search"
      onClick={toggleModal}
    />
  );
}
